const reasons = [
  {
    icon: 'ri-focus-3-line',
    title: 'Сначала задача бизнеса',
    desc: 'Мы начинаем не с универсального теста, а с понимания, зачем компании нужна оценка.',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Компетенции под конкретную роль',
    desc: 'Оцениваем то, что действительно влияет на результат конкретного сотрудника и должности.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Несколько источников информации',
    desc: 'При необходимости используем комбинацию методов, чтобы не делать выводы на основании одного показателя.',
  },
  {
    icon: 'ri-flag-2-line',
    title: 'Практический результат',
    desc: 'После оценки компания получает не только информацию, но и рекомендации по дальнейшим действиям.',
  },
  {
    icon: 'ri-links-line',
    title: 'Связь с обучением',
    desc: 'Результаты оценки могут использоваться для формирования корпоративных программ обучения.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Сопровождение развития',
    desc: 'При необходимости помогаем перевести результаты оценки в практику и дальнейшее развитие.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему оценка должна быть связана с развитием
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка — не самоцель, а инструмент, который помогает понять, как развивать сотрудников дальше.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-base md:text-lg font-medium text-gray-800 mt-10 max-w-3xl mx-auto leading-relaxed">
          Наша задача — не просто оценить сотрудников, а понять, как развивать их компетенции дальше.
        </p>
      </div>
    </section>
  );
}